<div *ngIf="visible()" [style]="{position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 9999}">
    
    <!-- For some reason, it refused to bind when using [src] and a variable, and it didn't have anything to do with SafeURL.  It just ignored it. -->
    
    <iframe *ngIf="!isProduction" src="http://localhost/missioncontrol/upgrade" (load)="onIframeLoad($event)"
        [style]="{position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 9999}"></iframe>

        <iframe *ngIf="isProduction" src="https://mc.ppm.org/missioncontrol/upgrade"
        [style]="{position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 9999}"></iframe>
    
</div>